import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';

import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import InputMask from 'react-input-mask';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import classnames from 'classnames';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Card, CardBody, Col, Container, Row, Modal, Button, ModalHeader, ModalBody, FormGroup, Label, Alert, TabContent, TabPane, NavItem, NavLink } from 'reactstrap';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { getPurchases, addPurchase, updatePurchase, deletePurchase, getArrivedPurchases } from '../../store/purchases/actions';

import PageLoader from '../../components/Loaders/pageLoader';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { Notification } from '../../components/Notifications/notifications';

const animatedComponents = makeAnimated();
const { SearchBar } = Search;
class PurchasesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: [],
      categories: [],
      listOfProducts: [],
      managerOptions: [],
      selectedProductsData: [],
      viewArrived: false,
      isEdit: false,
      modalNewOrder: false,
      skipSecondStep: false,
      correctDate: true,
      alert: null,
      selectedMulti: null,
      eadDate: '',
      oneCNo: null,
      selfProducts: '',
      category: '',
      activeTab: 1,
      passedSteps: [1],
      PurchasesListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Product',
          dataField: 'product',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => (
            <>
              {order.products.length
                ? [...new Set(order.products.map((item) => item.product))].map((product, index) => (
                    <h5 className='font-size-16 mb-1' key={index}>
                      {product}
                    </h5>
                  ))
                : order.selfProducts.map((product, index) => (
                    <h5 className='font-size-16 mb-1' key={index}>
                      {product}
                    </h5>
                  ))}
            </>
          )
        },
        {
          text: 'Quantity',
          dataField: 'qty',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => (
            <>
              {order.qty.map((qt, index) => (
                <h5 className='font-size-16 mb-1' key={index}>
                  {qt}
                </h5>
              ))}
            </>
          )
        },
        {
          text: 'Sales Manager',
          dataField: 'managers',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => (
            <>
              {order.managers.map((item) => (
                <h5 className='font-size-16 mb-1' key={item._id}>
                  {item.fname} {item.sname}
                </h5>
              ))}
              {order.all && 'All'}
            </>
          )
        },
        {
          text: 'EAD',
          dataField: 'ead',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => <h5 className='font-size-16 mb-1'>{order.ead != null && new Date(order.ead).toLocaleDateString('en-GB')}</h5>
        },
        {
          text: 'Tracking',
          dataField: 'tracker',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => <h5 className='font-size-16 name-width mb-1'>{order.tracker}</h5>
        },
        {
          text: 'InvoiceNo',
          dataField: 'invoices',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => (
            <>
              {order.invoices &&
                order.invoices.map((inv, index) => (
                  <h5 className='font-size-16 mb-1' key={index}>
                    {parseInt(inv.split('-')[1], 10)} {/* Convert to number to remove leading zeros */}
                  </h5>
                ))}
            </>
          )
        },
        {
          text: '1C Number',
          dataField: 'cNo',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => <h5 className='font-size-16 mb-1'>{order.cNo}</h5>
        },
        {
          text: 'Comments',
          dataField: 'comments',
          sort: true,
          hidden: false,
          editable: false,
          formatter: (cellContent, order) => <h5 className='font-size-16 mb-1'>{order.comments}</h5>
        },
        {
          dataField: 'menu',
          //   isDummyField: true,
          text: 'Action',
          editable: false,
          formatter: (cellContent, order) => (
            <div className='d-flex gap-3'>
              {this.props.profileData.permissions.includes('purchaseListAccess') && (
                <>
                  {!order.arrived && (
                    <Link className='text-warning' to='#'>
                      <i
                        className='mdi mdi-pencil font-size-18'
                        onClick={(e) => {
                          this.handleEditOrderClick(e, order);
                          this.toggleTab(this.state.activeTab + 2);
                        }}
                      ></i>
                    </Link>
                  )}
                  <Link className={order.arrived ? 'text-danger' : 'text-success'} to='#'>
                    <i className='mdi mdi-truck-delivery-outline font-size-18' onClick={() => this.markAsArrived(order)}></i>
                  </Link>
                  {!order.arrived && (
                    <Link className='text-danger' to='#'>
                      <i className='mdi mdi-delete font-size-18' onClick={() => this.handleDeletePurchaseRequest(order)}></i>
                    </Link>
                  )}
                </>
              )}
              {/* )} */}
            </div>
          )
        }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.rowClasses = this.rowClasses.bind(this);

    this.handleNewOrderClick = this.handleNewOrderClick.bind(this);
    this.handleHideCompletedOrders = this.handleHideCompletedOrders.bind(this);
    this.handleViewCompletedOrders = this.handleViewCompletedOrders.bind(this);
    this.handleEditOrderClick = this.handleEditOrderClick.bind(this);
    this.markAsArrived = this.markAsArrived.bind(this);
    this.toggleNewOrderModal = this.toggleNewOrderModal.bind(this);
    this.addManagersToOptions = this.addManagersToOptions.bind(this);
    this.toggleTab = this.toggleTab.bind(this);

    this.clearSelection = this.clearSelection.bind(this);
    this.handleFilterProductsList = this.handleFilterProductsList.bind(this);
    this.onChangeSelfAdd = this.onChangeSelfAdd.bind(this);
    this.submitFirstStep = this.submitFirstStep.bind(this);

    this.handleGroupedData = this.handleGroupedData.bind(this);
    this.submitSecondStep = this.submitSecondStep.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.resetSelectedMulti = this.resetSelectedMulti.bind(this);
    this.newOrderSubmit = this.newOrderSubmit.bind(this);

    this.handleDeletePurchaseRequest = this.handleDeletePurchaseRequest.bind(this);
  }
  componentDidMount() {
    const { onGetPurchases } = this.props;
    onGetPurchases();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * Get screen height to set it for table
   */
  getScreenHeight = (click) => {
    if (document.getElementById('card-section') != null) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      const nodeList = document.querySelectorAll('.react-bootstrap-table');
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].setAttribute('style', 'height: calc(' + screenHeight + 'px - 120px); overflow: auto;');
      }
    }
  };
  /**
   * @param {Arr} row
   * @param {Int} rowIndex
   * @returns class to selected rows
   */
  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.arrived === true) {
      classes = 'completed-row';
    }
    return classes;
  };
  /**
   * Group received data into required array
   * @returns array
   */
  handleGroupedData = () => {
    const grouped = {};
    this.props.productsToOrder.forEach((item) => {
      const key = `${item.category}-${item.product}`;
      const id = item._id;
      const managerId = item.manager?._id;
      const invoice = item.cNo;
      const totalQty = item.qty;

      if (!grouped[key]) {
        grouped[key] = {
          ids: [id],
          managers: [managerId],
          invoices: [invoice],
          product: item.product,
          totalQty: totalQty,
          category: item.category
        };
      } else {
        grouped[key].ids.push(id);
        if (managerId && !grouped[key].managers.includes(managerId)) {
          grouped[key].managers.push(managerId);
        }
        if (invoice && !grouped[key].invoices.includes(invoice)) {
          grouped[key].invoices.push(invoice);
        }
        grouped[key].totalQty += totalQty;
      }
    });
    return Object.values(grouped);
  };
  /**
   * Empty orders array and set edit to false. Open new order modal
   */
  handleNewOrderClick = () => {
    this.setState({ selectedProduct: '', isEdit: false, listOfProducts: [], eadDate: '' });
    this.toggleNewOrderModal();
  };
  /**
   * Hide arrived orders
   */
  handleHideCompletedOrders = () => {
    const { purchases, onUpdatePurchase } = this.props;
    let updatePurchaseOrder = [];
    purchases.map((row) => {
      if (row.arrived) {
        updatePurchaseOrder = {
          _id: row._id,
          hidden: true
        };
        onUpdatePurchase(updatePurchaseOrder);
        updatePurchaseOrder = [];
      }
    });
  };
  /**
   * Hide arrived orders
   */
  handleViewCompletedOrders = (e) => {
    const { onGetArrivedPurchases } = this.props;
    const { viewArrived } = this.state;
    if (viewArrived) {
      e.preventDefault();
      window.location.reload();
    } else {
      this.setState({ viewArrived: true });
      onGetArrivedPurchases('arrived');
    }
    // let updatePurchaseOrder = [];
    // purchases.map((row) => {
    //   if (row.arrived) {
    //     updatePurchaseOrder = {
    //       _id: row._id,
    //       hidden: true
    //     }
    //     onUpdatePurchase(updatePurchaseOrder);
    //     updatePurchaseOrder = []
    //   }
    // });
  };
  /**
   * Assign values for order editing
   * @param {*} purchase
   */
  handleEditOrderClick = (e, purchase) => {
    this.toggleNewOrderModal();
    let self_products = [];
    let selectedMulti = [];
    purchase.selfProducts.map((prod) => {
      self_products.push({ product: prod });
    });
    purchase.managers.map((manager) => {
      selectedMulti.push({
        label: manager.fname + ' ' + manager.sname,
        value: manager._id,
        bitrixID: manager.bitrixID
      });
    });
    if (purchase.all) {
      selectedMulti.push({
        label: 'All',
        value: '000'
      });
    }
    this.setState({
      selectedProduct: {
        _id: purchase._id,
        cNo: purchase.cNo,
        category: purchase.category,
        tracker: purchase.tracker,
        products: purchase.products.length !== 0 ? purchase.products : self_products,
        totalQty: purchase.qty,
        comments: purchase.comments
      },
      selectedMulti: selectedMulti,
      eadDate: purchase.ead != null ? new Date(purchase.ead).toLocaleDateString('en-GB') : '',
      isEdit: true
    });
  };
  /**
   * Set requested order as arrived
   * @param {*} purchase
   */
  markAsArrived = (purchase) => {
    const { onUpdatePurchase } = this.props;
    let strPurchased = '';
    let invoices = purchase.invoices ? purchase.invoices.map(invoice => invoice.split('-')[1].replace(/^0+/, '')).join(', ') : '';

    if (purchase.selfProducts.length !== 0) {
      purchase.selfProducts.forEach((product, index) => {
        strPurchased += `${product} quantity: ${purchase.qty[index]}\n`;
      });
    }
    const updatePurchaseOrder = {
      _id: purchase._id,
      productsList: purchase.products,
      arrived: purchase.arrived === true ? false : true,
      ead: purchase.ead,
      sndInvoices: invoices,
      tracker: purchase.tracker,
      comments: purchase.comments,
      page: 'productsArrived',
      notifications: purchase.managers,
      strPurchased: strPurchased
    };
    onUpdatePurchase(updatePurchaseOrder);
  };
  /**
   * Toggle new order modal
   */
  toggleNewOrderModal = () => {
    const { productsToOrder } = this.props;
    const categories = [...new Set(productsToOrder.map((obj) => obj.category))];
    this.addManagersToOptions();
    this.setState((prevState) => ({
      modalNewOrder: !prevState.modalNewOrder,
      activeTab: 1,
      categories: categories,
      selectedProductsData: []
    }));
  };
  /**
   * Display selected tab
   * @param {int} tab
   */
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        var modifiedSteps = [...this.state.passedSteps, tab];
        this.setState({ activeTab: tab, passedSteps: modifiedSteps });
      }
    }
  }
  /**
   * Clear option selection
   * @param {*} event
   */
  clearSelection = (event) => {
    document.getElementById('products').value = '';
    var elements = document.getElementById('products').options;
    for (var i = 0; i < elements.length; i++) {
      elements[i].selected = false;
    }
  };
  /**
   * Filter products by categories
   * @param {*} event
   */
  handleFilterProductsList = (event) => {
    let listOfProducts = [];
    let category = event.target.value;
    this.handleGroupedData().map((order) => {
      if (order.category === event.target.value) {
        listOfProducts.push(order);
      }
    });
    this.setState({ listOfProducts: listOfProducts, category: category });
  };
  /**
   * Filter products by categories
   * @param {*} event
   */
  onChangeSelfAdd = (event) => {
    let selfProducts = event.target.value;
    this.setState({ selfProducts: selfProducts });
  };
  /**
   * Submit first step of the form
   * @param {*} e
   * @param {array} values
   */
  submitFirstStep = (e, values) => {
    const { activeTab } = this.state;
    let new_data = [];

    if (values['products'].length !== 0) {
      new_data = this.handleGroupedData().filter((obj) => {
        const ids = obj.ids.join(',');
        return values['products'].includes(ids);
      });

      this.setState({ selectedProductsData: new_data, skipSecondStep: false });
      this.toggleTab(activeTab + 1);
    } else {
      let self_products = [];
      values['selfProducts'].split(/\r?\n/).map((val) => {
        return val !== '' && self_products.push(val);
      });
      new_data = self_products.map((str) => {
        const [product, qty, invoice, category, comments] = str.split('qty');
        return {
          ids: [],
          managers: [],
          invoice: invoice.trim(),
          product: product.trim(),
          totalQty: qty.trim(),
          category: category.trim(),
          comments: comments ? comments.trim() : ''
        };
      });
      this.setState({
        selectedProductsData: new_data,
        category: new_data[0].category,
        oneCNo: new_data[0].invoice,
        skipSecondStep: true
      });
      this.toggleTab(this.state.activeTab + 2);
    }
  };
  /**
   * Submit second step of the form
   * @param {*} e
   * @param {array} values
   */
  submitSecondStep = (e, values) => {
    const { managers } = this.props;
    const { selectedProductsData, activeTab } = this.state;
    let selectedMulti = [];
    const processedIds = new Set();
    let excel_string = '';
    let prev = '0';
    selectedProductsData.map((product, index) => {
      Object.keys(values).forEach((key) => {
        if (key === 'qty' + index) {
          selectedProductsData[index].totalQty = parseInt(values[key]);
        }
      });
    });
    managers.forEach((manager) => {
      selectedProductsData.forEach((data) => {
        if (data.managers.includes(manager._id) && !processedIds.has(manager._id)) {
          selectedMulti.push({
            label: manager.fname + ' ' + manager.sname,
            value: manager._id,
            bitrixID: manager.bitrixID
          });
          processedIds.add(manager._id);
        }
      });
    });
    for (const key in values) {
      if (prev === key.slice(-1)) {
        excel_string += values[key] + '\t';
      } else {
        excel_string += '\n' + values[key] + '\t';
      }
      prev = key.slice(-1);
    }
    // navigator.clipboard.writeText(excel_string);
    this.setState({ selectedProductsData: selectedProductsData, selectedMulti: selectedMulti });
    this.toggleTab(activeTab + 1);
  };
  /**
   * Set EAD for an order
   * @param {*} event
   */
  onChange = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      this.setState({ correctDate: false });
    } else {
      this.setState({
        correctDate: true,
        [event.target.name]: event.target.value
      });
    }
  };
  /**
   * Add managers to options for select
   */
  addManagersToOptions = () => {
    const { managers } = this.props;
    let managerOptions = [];
    managers.map((manager) => {
      managerOptions.push({
        label: manager.fname + ' ' + manager.sname,
        value: manager._id,
        bitrixID: manager.bitrixID
      });
      return managerOptions;
    });
    managerOptions.push({
      label: 'All',
      value: '000'
    });
    this.setState({ managerOptions });
  };
  /**
   * Set selected options for multiselect inside step 3
   * @param {array} selectedMulti
   * @returns true or false
   */
  handleMultiSelect = (selectedMulti) => this.setState({ selectedMulti });
  /**
   * Reset selected multi array on previous button click
   */
  resetSelectedMulti = () => this.setState({ selectedMulti: [] });
  /**
   * Submit order data to database
   * @param {*} e
   * @param {array} values
   */
  newOrderSubmit = (e, values) => {
    const { onAddPurchase, onUpdatePurchase, productsToOrder, products } = this.props;
    const { selectedProductsData, eadDate, selectedMulti, selectedProduct, isEdit } = this.state;
    if (isEdit) {
      const updatePurchaseOrder = {
        _id: selectedProduct._id,
        cNo: values.cNo,
        ead: eadDate.split('/').reverse().join('-'),
        tracker: values.tracker,
        comments: values.comments,
        category: selectedProduct.category,
        managers: [...new Set(selectedMulti.filter((product) => product.value !== '000').flatMap((product) => product.value))],
        productsList: selectedProduct.products,
        all: selectedMulti.some((product) => product.value === '000'),
        arrived: false,
        module: 'Bot Purchase Notification',
        option: 'purchaseRequestEdit',
        // page: 'purchaseRequestEdit',
        notifications: ''
      };
      // notifications data
      const notifications = products
        .filter((obj) => updatePurchaseOrder.productsList.map((obj) => obj._id).includes(obj._id))
        .reduce((acc, { manager, product, qty }) => {
          const existingIndex = acc.findIndex((item) => item.bitrixID === manager.bitrixID);
          if (existingIndex >= 0) {
            acc[existingIndex].products += `\n${product} quantity: ${qty}`;
          } else {
            acc.push({
              fname: manager.fname,
              sname: manager.sname,
              bitrixID: manager.bitrixID,
              products: `${product} quantity: ${qty}`
            });
          }
          return acc;
        }, []);
      updatePurchaseOrder.notifications = notifications;
      onUpdatePurchase(updatePurchaseOrder);
    } else {
      const newPurchaseOrder = {
        cNo: values['cNo'],
        ead: eadDate.split('/').reverse().join('-'),
        tracker: values['tracker'],
        comments: values['comments'],
        category: selectedProductsData[0].category,
        managers: [...new Set(selectedMulti.filter((product) => product.value !== '000').flatMap((product) => product.value))],
        all: selectedMulti.some((product) => product.value === '000'),
        products: selectedProductsData[0].ids.length !== 0 ? selectedProductsData.flatMap((product) => product.ids) : [],
        selfProducts: selectedProductsData[0].ids.length === 0 ? selectedProductsData.flatMap((product) => product.product) : [],
        qty: selectedProductsData.flatMap((product) => product.totalQty),
        page: 'purchaseRequest',
        notifications: ''
      };
      // notifications data
      const notifications = productsToOrder
        .filter((obj) => newPurchaseOrder.products.includes(obj._id))
        .reduce((acc, { manager, product, qty }) => {
          const existingIndex = acc.findIndex((item) => item.bitrixID === manager.bitrixID);
          if (existingIndex >= 0) {
            acc[existingIndex].products += `\n${product} quantity: ${qty}`;
          } else {
            acc.push({
              fname: manager.fname,
              sname: manager.sname,
              bitrixID: manager.bitrixID,
              products: `${product} quantity: ${qty}`
            });
          }
          return acc;
        }, []);
      newPurchaseOrder.notifications = notifications;
      onAddPurchase(newPurchaseOrder);
    }
    this.toggleNewOrderModal();
  };
  /**
   * Confirm order deletion
   * @param {array} purchase
   */
  handleDeletePurchaseRequest = (purchase) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deletePurchaseRequestAlert(purchase)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Delete order from database
   * @param {array} purchase
   */
  deletePurchaseRequestAlert = (purchase) => {
    const { onDeletePurchase } = this.props;
    onDeletePurchase(purchase);
    this.hideAlert();
  };
  /**
   * Hide alert
   * @returns hidden alert
   */
  hideAlert = () => this.setState({ alert: null });

  render() {
    // const { SearchBar } = Search;
    const { profileData, loading, arrived_purchases, purchases } = this.props;
    console.log(this.props)
    const {
      PurchasesListColumns,
      modalNewOrder,
      activeTab,
      passedSteps,
      selfProducts,
      categories,
      category,
      listOfProducts,
      selectedProductsData,
      selectedProduct,
      oneCNo,
      eadDate,
      correctDate,
      selectedMulti,
      managerOptions,
      alert,
      skipSecondStep,
      isEdit,
      viewArrived
    } = this.state;

    const pageOptions = {
      sizePerPage: purchases.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize: purchases.length,
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'date', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className='page-content'>
          <MetaTags>
            <title>Purchases</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('purchaseRqstdPrdAccess') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title='Korupharma' breadcrumbItem='Purchases' />
                <Row>
                  <Col lg='12'>
                    <div className='pcss3t pcss3t-effect-scale pcss3t-theme-1'>
                      <input type='radio' name='pcss3t' id='tab1' defaultChecked className='tab-content-1' />
                      <label htmlFor='tab1'>
                        <i className='mdi mdi-calendar'></i> Products
                      </label>

                      <input type='radio' name='pcss3t' id='tab2' className='tab-content-2' />
                      <label htmlFor='tab2'>
                        <i className='mdi mdi-calendar-multiple-check'></i> OEM
                      </label>

                      <input type='radio' name='pcss3t' id='tab3' className='tab-content-3' />
                      <label htmlFor='tab3'>
                        <i className='mdi mdi-account-multiple'></i> Threads
                      </label>
                      {profileData.permissions.includes('purchaseListAccess') && (
                        <>
                          <Button color='primary' className='font-16 btn-block btn btn-primary ms-2 me-2 btn-lg' onClick={this.handleNewOrderClick} id='create-order-btn'>
                            <i className='mdi mdi-plus-circle-outline me-1' />
                            Generate New Order
                          </Button>
                          <Modal size='xl' autoFocus={false} isOpen={modalNewOrder} className={this.props.className} toggle={this.toggleNewOrderModal}>
                            <ModalHeader toggle={this.toggleNewOrderModal} tag='h4'>
                              {!!isEdit ? 'Update Order' : 'Generate New Order'}
                            </ModalHeader>
                            <ModalBody>
                              <div className='wizard clearfix'>
                                <div className='steps clearfix'>
                                  <ul>
                                    <NavItem className={classnames({ current: activeTab === 1 })}>
                                      <NavLink
                                        className={classnames({ active: activeTab === 1 })}
                                        onClick={() => {
                                          this.toggleTab(1);
                                        }}
                                      >
                                        <span className='number'>1.</span> Select Products from the List
                                      </NavLink>
                                    </NavItem>
                                    <NavItem className={classnames({ current: activeTab === 2 })}>
                                      <NavLink
                                        disabled={!(passedSteps || []).includes(2)}
                                        className={classnames({ active: activeTab === 2 })}
                                        onClick={() => {
                                          this.toggleTab(2);
                                        }}
                                      >
                                        <span className='number'>2.</span> <span>Generate 1C Number</span>
                                      </NavLink>
                                    </NavItem>
                                    <NavItem className={classnames({ current: activeTab === 3 })}>
                                      <NavLink
                                        disabled={!(passedSteps || []).includes(3)}
                                        className={classnames({ active: activeTab === 3 })}
                                        onClick={() => {
                                          this.toggleTab(3);
                                        }}
                                      >
                                        <span className='number'>3.</span> <span>Create Order in the System</span>
                                      </NavLink>
                                    </NavItem>
                                  </ul>
                                </div>
                                <div className='content clearfix'>
                                  <TabContent activeTab={activeTab} className='body'>
                                    <TabPane tabId={1}>
                                      <AvForm id='myform' onValidSubmit={this.submitFirstStep}>
                                        <Row>
                                          <Col lg='12'>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='select'
                                                name='categories'
                                                id='categories'
                                                label='Categories'
                                                className='form-select'
                                                onClick={this.clearSelection}
                                                onChange={this.handleFilterProductsList}
                                                errorMessage='Please select category'
                                                validate={selfProducts !== '' ? { required: { value: false } } : { required: { value: true } }}
                                              >
                                                <option value=' '>Please Select Category</option>
                                                {categories.length !== 0 &&
                                                  categories.map((category, index) => {
                                                    return (
                                                      <option key={index} value={category}>
                                                        {category}
                                                      </option>
                                                    );
                                                  })}
                                              </AvField>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg='12'>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='select'
                                                name='products'
                                                id='products'
                                                size='8'
                                                multiple
                                                className='form-select'
                                                label='Product'
                                                errorMessage='Please select product'
                                                validate={selfProducts !== '' ? { required: { value: false } } : { required: { value: true } }}
                                              >
                                                {listOfProducts.map((product, index) => {
                                                  return (
                                                    <option key={index} value={product.ids}>
                                                      {product.product} Quantity: {product.totalQty} Category: {product.category}
                                                    </option>
                                                  );
                                                })}
                                              </AvField>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <b>OR Insert Yourself</b>
                                        <Row>
                                          <Col lg='12'>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                type='textarea'
                                                name='selfProducts'
                                                id='selfProducts'
                                                rows='8'
                                                className='font-size-20'
                                                label='Product'
                                                errorMessage='Please enter products'
                                                onChange={this.onChangeSelfAdd}
                                                validate={category !== '' ? { required: { value: false } } : { required: { value: true } }}
                                              ></AvField>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <div className='text-end'>
                                              <button className='btn btn-primary disabled me-3'>Previous</button>
                                              <button className='btn btn-primary'>Next</button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </TabPane>
                                    <TabPane tabId={2}>
                                      <AvForm id='FormName' onValidSubmit={this.submitSecondStep}>
                                        <Row>
                                          <Col lg='12'>Please use the copy icon to get the list of produtcs and go to 1C to create an order.</Col>
                                        </Row>
                                        <Row>
                                          <Col lg='8'>
                                            <Label> Product Name</Label>
                                          </Col>
                                          <Col lg='1'>
                                            <Label> </Label>
                                          </Col>
                                          <Col lg='2'>
                                            <Label> Product Quantity</Label>
                                          </Col>
                                        </Row>
                                        <Row id='generatedRows'>
                                          {selectedProductsData.map((row, index) => {
                                            return (
                                              <Row key={index}>
                                                <Col lg='8'>
                                                  <FormGroup className='mb-3'>
                                                    <AvField name={`product${index}`} label='' disabled type='text' autoComplete='off' value={row.product} />
                                                  </FormGroup>
                                                </Col>
                                                <Col lg='1'>
                                                  <FormGroup className='mb-3'>
                                                    <AvField name={`empty${index}`} label='' type='hidden' autoComplete='off' value=' ' />
                                                  </FormGroup>
                                                </Col>
                                                <Col lg='2'>
                                                  <FormGroup className='mb-3'>
                                                    <AvField name={`qty${index}`} label='' type='text' autoComplete='off' value={row.totalQty} />
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                            );
                                          })}
                                        </Row>
                                        <Row>
                                          <Col>
                                            <div className='text-end'>
                                              <Link
                                                to='#'
                                                className='btn btn-primary me-3'
                                                onClick={() => {
                                                  this.toggleTab(activeTab - 1);
                                                }}
                                              >
                                                {' '}
                                                Previous{' '}
                                              </Link>
                                              <button className='btn btn-primary'>
                                                <i className='mdi mdi-content-copy font-size-18' id='edittooltip'></i>
                                                Copy Data & Next
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </TabPane>
                                    <TabPane tabId={3}>
                                      <AvForm id='' onValidSubmit={this.newOrderSubmit}>
                                        <Row>
                                          <Col lg='6'>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='cNo'
                                                label='1C Number'
                                                type='text'
                                                disabled={profileData.department.depName === 'Product Management Team' ? true : false}
                                                autoComplete='off'
                                                errorMessage='Please enter 1C Number'
                                                validate={{
                                                  required: {
                                                    value: true
                                                  }
                                                }}
                                                value={selectedProduct ? selectedProduct.cNo : oneCNo !== null ? oneCNo : ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col lg='6'>
                                            <FormGroup className='mb-3'>
                                              <Label>Estimated Delivery Date</Label>
                                              <InputMask
                                                mask='99/99/9999'
                                                value={eadDate}
                                                name='eadDate'
                                                onChange={this.onChange}
                                                className={correctDate ? ' form-control input-mask' : 'form-control input-mask is-invalid'}
                                              />
                                              {!correctDate && <div className='invalid-feedback'> Invalid Date. Please use dd/mm/yyyy format</div>}
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg='6'>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='tracker'
                                                label='Tracking'
                                                type='text'
                                                autoComplete='off'
                                                disabled={profileData.department.depName === 'Product Management Team' ? true : false}
                                                value={selectedProduct ? selectedProduct.tracker : ''}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col lg='6'>
                                            <FormGroup className='mb-3'>
                                              <Label for='managersSelected'>Managers who ordered</Label>
                                              <Select
                                                value={selectedMulti}
                                                isMulti={true}
                                                onChange={this.handleMultiSelect}
                                                options={managerOptions}
                                                classNamePrefix='select2-selection'
                                                closeMenuOnSelect={false}
                                                disabled={profileData.department.depName === 'Product Management Team' ? true : false}
                                                components={animatedComponents}
                                                name='managersSelected'
                                                id='managersSelected'
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col md={6}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='productList'
                                                label='Products'
                                                type='textarea'
                                                className='font-size-20'
                                                rows={15}
                                                // disabled={profileData.department.depName === 'Product Management Team' ? true : false }
                                                disabled={true}
                                                id='productField'
                                                // value={ updatedSelectedRowsData ? updatedSelectedRowsData : selectedProduct ? selectedProduct.products : '' }
                                                value={
                                                  selectedProductsData.length !== 0
                                                    ? selectedProductsData.map((product) => `${product.product} qty${product.totalQty}`).join('\n')
                                                    : // : selectedProduct.length !== 0 ? selectedProduct.products.map((p, i) => `${p.product} qty${selectedProduct.totalQty[i]}`).join('\n') : ''
                                                    selectedProduct.length !== 0
                                                    ? Object.entries(
                                                        selectedProduct.products.reduce((acc, curr, i) => {
                                                          const product = curr.product;
                                                          const qty = selectedProduct.totalQty[i];
                                                          if (!isNaN(qty)) {
                                                            acc[product] = (acc[product] || 0) + qty;
                                                          }
                                                          return acc;
                                                        }, {})
                                                      )
                                                        .map(([productName, qty]) => `${productName} qty${qty}`)
                                                        .join('\n')
                                                    : ''
                                                }
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md={6}>
                                            <FormGroup className='mb-3'>
                                              <AvField
                                                name='comments'
                                                label='Comments'
                                                autoComplete='off'
                                                className='font-size-20'
                                                type='textarea'
                                                disabled={profileData.department.depName === 'Product Management Team' ? true : false}
                                                // value={ selectedProduct ? selectedProduct.comments : comments != '' ? comments : ''}
                                                value={selectedProduct ? selectedProduct.comments : ''}
                                                rows='15'
                                              />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <div className='text-end'>
                                              <Link
                                                to='#'
                                                className={isEdit ? 'btn btn-primary me-3 disabled' : 'btn btn-primary me-3'}
                                                onClick={() => {
                                                  this.toggleTab(activeTab - (skipSecondStep === true ? 2 : 1));
                                                  this.resetSelectedMulti();
                                                }}
                                              >
                                                {' '}
                                                Previous{' '}
                                              </Link>
                                              <button className='btn btn-primary'>{isEdit ? 'Edit Order' : 'Add Order'}</button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </TabPane>
                                  </TabContent>
                                </div>
                              </div>
                            </ModalBody>
                          </Modal>
                          <Button color='primary' className='font-16 btn-block btn btn-warning me-2 btn-lg' onClick={this.handleHideCompletedOrders} id='create-order-btn'>
                            <i className='mdi mdi-reload me-1' />
                            Hide Arrived Orders
                          </Button>
                          <Button color='primary' className='font-16 btn-block btn btn-dark btn-lg' onClick={this.handleViewCompletedOrders} id='create-order-btn'>
                            <i className={viewArrived ? 'mdi mdi-eye-off me-1' : 'mdi mdi-eye me-1'} />
                            {viewArrived ? 'Reset' : 'View Arrived Orders'}
                          </Button>
                          <Notification className='d-inline' compData={arrived_purchases.length === 0 ? purchases : arrived_purchases } keyWord='purchase' module='Bot Purchase Notification' />
                        </>
                      )}
                      <ul>
                        <li className='tab-content tab-content-1 typography'>
                          <Row id='card-section'>
                            <Col lg='12'>
                              <Card>
                                <CardBody className='cardBodySticky'>
                                  <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField='_id'
                                    columns={PurchasesListColumns}
                                    data={
                                      arrived_purchases.length === 0
                                        ? purchases.filter((el) => {
                                            return el.category === 'PRODUCTS';
                                          })
                                        : arrived_purchases.filter((el) => {
                                            return el.category === 'PRODUCTS';
                                          })
                                    }
                                  >
                                    {({ paginationProps, paginationTableProps }) => (
                                      <ToolkitProvider
                                        keyField='_id'
                                        columns={PurchasesListColumns}
                                        data={
                                          arrived_purchases.length === 0
                                            ? purchases.filter((el) => {
                                                return el.category === 'PRODUCTS';
                                              })
                                            : arrived_purchases.filter((el) => {
                                                return el.category === 'PRODUCTS';
                                              })
                                        }
                                        search
                                      >
                                        {(toolkitprops) => (
                                          <React.Fragment>
                                            <Row id='table-section'>
                                              <BootstrapTable
                                                {...toolkitprops.baseProps}
                                                {...paginationTableProps}
                                                defaultSorted={defaultSorted}
                                                rowClasses={this.rowClasses}
                                                classes={'table align-middle table-nowrap'}
                                                headerClasses='header-class is-sticky-hdr'
                                                id='tableScroll'
                                                filter={filterFactory()}
                                                responsive
                                              />
                                            </Row>
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                  </PaginationProvider>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </li>
                        <li className='tab-content tab-content-2 typography'>
                          <Row id='card-section'>
                            <Col lg='12'>
                              <Card>
                                <CardBody className='cardBodySticky'>
                                  <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField='_id'
                                    columns={PurchasesListColumns}
                                    data={
                                      arrived_purchases.length === 0
                                        ? purchases.filter((el) => {
                                            return el.category === 'OEM';
                                          })
                                        : arrived_purchases.filter((el) => {
                                            return el.category === 'OEM';
                                          })
                                    }
                                  >
                                    {({ paginationProps, paginationTableProps }) => (
                                      <ToolkitProvider
                                        keyField='_id'
                                        columns={PurchasesListColumns}
                                        data={
                                          arrived_purchases.length === 0
                                            ? purchases.filter((el) => {
                                                return el.category === 'OEM';
                                              })
                                            : arrived_purchases.filter((el) => {
                                                return el.category === 'OEM';
                                              })
                                        }
                                        search
                                      >
                                        {(toolkitprops) => (
                                          <React.Fragment>
                                            <Row id='table-section'>
                                              <BootstrapTable
                                                {...toolkitprops.baseProps}
                                                {...paginationTableProps}
                                                defaultSorted={defaultSorted}
                                                rowClasses={this.rowClasses}
                                                classes={'table align-middle table-nowrap'}
                                                headerClasses='header-class is-sticky-hdr'
                                                id='tableScroll'
                                                filter={filterFactory()}
                                                responsive
                                              />
                                            </Row>
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                  </PaginationProvider>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </li>
                        <li className='tab-content tab-content-3 typography'>
                          <Row id='card-section'>
                            <Col lg='12'>
                              <Card>
                                <CardBody className='cardBodySticky'>
                                  <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField='_id'
                                    columns={PurchasesListColumns}
                                    data={
                                      arrived_purchases.length === 0
                                        ? purchases.filter((el) => {
                                            return el.category === 'THREADS';
                                          })
                                        : arrived_purchases.filter((el) => {
                                            return el.category === 'THREADS';
                                          })
                                    }
                                  >
                                    {({ paginationProps, paginationTableProps }) => (
                                      <ToolkitProvider
                                        keyField='_id'
                                        columns={PurchasesListColumns}
                                        data={
                                          arrived_purchases.length === 0
                                            ? purchases.filter((el) => {
                                                return el.category === 'THREADS';
                                              })
                                            : arrived_purchases.filter((el) => {
                                                return el.category === 'THREADS';
                                              })
                                        }
                                        search
                                      >
                                        {(toolkitprops) => (
                                          <React.Fragment>
                                            <Row id='table-section'>
                                              <BootstrapTable
                                                {...toolkitprops.baseProps}
                                                {...paginationTableProps}
                                                defaultSorted={defaultSorted}
                                                rowClasses={this.rowClasses}
                                                classes={'table align-middle table-nowrap'}
                                                headerClasses='header-class is-sticky-hdr'
                                                id='tableScroll'
                                                filter={filterFactory()}
                                                responsive
                                              />
                                            </Row>
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                  </PaginationProvider>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </li>
                      </ul>
                    </div>
                    {alert}
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PurchasesList.propTypes = {
  purchases: PropTypes.array,
  onGetPurchases: PropTypes.func,
  onAddPurchase: PropTypes.func,
  onUpdatePurchase: PropTypes.func,
  onDeletePurchase: PropTypes.func
};

const mapStateToProps = ({ purchases }) => ({
  purchases: purchases.purchases,
  arrived_purchases: purchases.arrived_purchases,
  productsToOrder: purchases.productsToOrder,
  products: purchases.products,
  managers: purchases.managers,
  loading: purchases.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetPurchases: () => dispatch(getPurchases()),
  onAddPurchase: (purchase) => dispatch(addPurchase(purchase)),
  onUpdatePurchase: (purchase) => dispatch(updatePurchase(purchase)),
  onDeletePurchase: (purchase) => dispatch(deletePurchase(purchase)),
  onGetArrivedPurchases: (id) => dispatch(getArrivedPurchases(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchasesList));
